<button
  mat-icon-button
  id="cancel-action"
  [disabled]="disabled"
  [matTooltip]="showUndoIcon() ? undoIconData.toolTip : 'Cancel'"
  [matTooltipPosition]="tooltipPosition"
  i18n-matTooltip="@@CancelOrderCancelIconTooltip"
>
  @if (showUndoIcon()) {
  <span class="material-icons-outlined undo-icon" (click)="undoCancelOrder()"
    >undo
  </span>
  <span
    class="mat-circle material-icons-round"
    [ngClass]="undoIconData.badgeIcon"
  >
    {{ undoIconData.badgeIcon }}
  </span>
  } @else {
  <span class="material-icons-outlined" (click)="cancelOrder()"> cancel </span>
  }
</button>
